import { render, staticRenderFns } from "./classManagement.vue?vue&type=template&id=a96adc96&"
import script from "./classManagement.vue?vue&type=script&lang=js&"
export * from "./classManagement.vue?vue&type=script&lang=js&"
import style0 from "./classManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "classManagement.vue"
export default component.exports